var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "error-content",
        {
          attrs: {
            code: _vm.$t("system::common::expired-code"),
            desc: _vm.$t("system::common::expired-desc"),
            src: _vm.src,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOwnMerchant,
                  expression: "isOwnMerchant",
                },
              ],
              staticStyle: { "margin-top": "24px" },
              attrs: { slot: "btn_back" },
              slot: "btn_back",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toUrl } },
                [_vm._v(_vm._s(_vm.$t("system::common::expired-btn")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }